import { Theme } from "./types/theme";

// Default themes objects
export { defaultMTBTheme, MTB_PRIMARY_GREEN } from "./defaultMTBTheme";
export { mtbChakraConfig } from "./chakraTheme";
export { breakpoints, overrides } from "./defaultMTBTheme";
// types
export type { Theme };
// images to be used in admin and client app
export * from "./images";
//utils
export { getRgbaColor } from "./utils/getRgbaColor";
